import axios from "../../../services/axios-config";

export async function getCompanyCollaborators({ companyId }) {
  const response = await axios.get("/admin/companies/collaborators", {
    params: { companyId },
  });

  return response?.data?.collaborators || [];
}
